import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=c27baa7a&"
import script from "./TransitionExpand.vue?vue&type=script&lang=ts&"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports